import React from 'react';

function FixHeader(props) {
  const { productName, productPicture } = props;
  return (
    <div className="fix-float-header">
      <img
        src={productPicture}
        alt="productPicture"
        className="float-header-img"
      />
      <span className="float-header-name">{productName}</span>
      <div className="float-header-line" />
    </div>
  );
}

export default FixHeader;
